import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../constants";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import JisButton from "../components/controls/jisButton";
import CaseSearch from "../components/core/case_search";
import Gazette from "../components/core/gazette";
import Pagenated from "../components/pagenated";
import CaseDetails from "../components/core/caseDetails";
import JisDialogForm from "../components/formdialog";

import wordicon from "../assets/ms_word.png";
import excelicon from "../assets/ms_excel.png";
import pdficon from "../assets/pdf.png";
import DeadlineBadge from "../components/controls/deadlinebadge";
import JisTabButton from "../components/controls/jisTabButton";
import CustomSearchSortHeader from "../components/core/CustomSearchSortHeader";

function PsaCases() {
  const FeeTYPEID = 31; //this supose to be review fee
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired,holidays } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [count, setCount] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(false);
  const [isGazette, setIsGazette] = useState(false);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [tab, setTab] = useState("pending");

  useEffect(() => {
    if (pageIndex >= 0) {
      if (search != null) {
        onSearch(search);
      }
    } else {
      setPageIndex(0);
    }
  }, [pageIndex, pageSize, search, tab]);

  const onSearch = async (sear) => {
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/psa-cases/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);

      if (data.code == 0) {
        let filteredCases = data.items;
        if (isCFOFastTracking) { //was formally !isCFOFastTracking
          filteredCases = data.items.filter(
            (opt) =>
              opt.case?.caseCategoryId !== 4 &&
              opt.case?.processType !== "Fast Track"
          );
        }
        setCases(filteredCases);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/psa-cases/${pageIndex}/${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await resp.json();
      setLoading(false);
      
      if (data.code == 0) {
        let filteredCases = data.items;
        if (!isCFOFastTracking) {
          filteredCases = data.items.filter(
            (opt) =>
              opt.case?.caseCategoryId !== 4 &&
              opt.case?.processType !== "Fast Track"
          );
        }
        setCases(filteredCases);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onContinue = (fee, ind) => {
    navigate(`/case-details/${fee.caseId}`);
    // setActive(fee);
    // setIndex(ind);
    // setOpenCase(true);
  };

  // const onCloseOpenCase = () => {
  //   setActive(null);
  //   setIndex(-1);
  //   setOpenCase(false);
  // };

  const onUpdateFee = (fee, ind) => {
    setIndex(ind);
    setIsGazette(true);
    setActive(fee);
  };

  const onGazetteProceed = (e) => {
    console.log("after processing... here is value");
    console.log(e);

    const ft = cases.filter((_, i) => i !== index);
    setCases(ft);
    setIsGazette(false);
    //setcasefeeId(e.feeid);
    //  setIsSuccess(e.isPaid);
    //proceed to payment.
  };
  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };
  const onChangeTab = (t) => {
    setTab(t);
    setPageIndex(0);
  };

  const isCFOFastTracking = profile.role.id === 33;
  return (
    <div>
      {/* <CaseSearch onSearch={onDirectSearch} frequentData={frequentData} /> */}
      <CustomSearchSortHeader
        onSearch={onDirectSearch}
        frequentData={frequentData}
        caseCategoryId={isCFOFastTracking ? "4" : ""}
        isSearchAndDateOnly={isCFOFastTracking}
        excludeCategoryIds={isCFOFastTracking ? [] : [4]}
        excludeProcessTypes={isCFOFastTracking ? [] : ["Fast Track"]}
      />

      <div className="tab_body">
        <div className="tab_section">
          <JisTabButton
            isActive={tab == "pending"}
            title="Pending Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("pending")}
          />

          <JisTabButton
            isActive={tab == "revised"}
            title="Revised Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("revised")}
          />

          <JisTabButton
            isActive={tab == "completed"}
            title="Processed Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("completed")}
          />
        </div>
        <div className="tab_view"></div>
      </div>

      {/* <div className='exportdiv'>
  <img src={wordicon} />
  <img src={excelicon} />
  <img src={pdficon} />
</div> */}
      <div className="table">
        <div class="section-cases">
          <span>PSA Cases</span>
          {/* <span className="total">{count}</span> */}
        </div>
        <div className="table-wrapper">
          <table class="case-table">
            <thead>
              <tr>
                <th className="col-title">Suit Number</th>
                <th className="col-title">Case Title</th>
                <th className="col-medium">Filing Type</th>
                <th className="col-medium">Classification</th>
                <th className="col-medium">Date Initiated</th>
                <th className="col-medium">Status Level</th>
                {tab == "pending" && <th>SLA</th>}
                {tab == "revised" && (
                  <>
                    <th>Fee Paid</th>
                    <th>Outstanding Fee</th>
                    <th>Actual Fee</th>
                    <th className="col-medium">Payment Status</th>
                    <th className="col-medium">Document Status</th>
                  </>
                )}
                {tab == "pending" && (
                  <>
                    <th>Fee</th>
                  </>
                )}
                {tab === "completed" && <th>Fee</th>}
                <th className="col-title">Details</th>
                {tab != "completed" && <th className="col-action">Action</th>}
              </tr>
            </thead>
            <tbody>
              {cases?.map((opt, index) => {
                const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                return (
                  <tr key={index}>
                    <td
                      style={{
                        backgroundColor: `${
                          Constants.getItemById(
                            frequentData?.casecategories,
                            opt.case?.caseCategoryId
                          )?.colour
                        }`,
                      }}
                    >
                      {" "}
                      {opt.case.caseNumber ?? opt.case.referenceNumber}
                    </td>
                    <td>{opt.case?.caseTitle || "N/A"}</td>
                    <td>
                      {Constants.getItemById(
                        frequentData?.casetype,
                        opt.case?.caseTypeId
                      )?.caseType1 || "N/A"}
                    </td>
                    <td>
                      {" "}
                      {Constants.getItemById(
                        frequentData?.casecategories,
                        opt.case?.caseCategoryId
                      )?.categoryTitle || "N/A"}
                    </td>
                    <td>
                      {" "}
                      {Constants.momentDate(opt.createdOn).format(
                        "DD MMM, YYYY"
                      ) || "N/A"}
                    </td>
                    <td>
                      {Constants.getItemById(
                        frequentData?.casestatuses,
                        opt.case?.caseStatusId
                      )?.description || "N/A"}
                    </td>
                    {tab == "pending" && (
                      <td>
                        <DeadlineBadge dateString={opt.case?.slaExpire} />
                      </td>
                    )}
                    {tab == "revised" && (
                      <>
                        <td>
                          {opt.prevAmount
                            ? `₦${Constants.formatCurrency(opt.prevAmount)}`
                            : "N/A"}
                        </td>
                        <td>
                          {opt.fee
                            ? `₦${Constants.formatCurrency(opt.fee)}`
                            : "N/A"}
                        </td>
                        <td>
                          {`₦${Constants.formatCurrency(
                            (opt.prevAmount || 0) + (opt.fee || 0)
                          )}`}
                        </td>
                        <td>{opt.isPaid ? "Paid" : "Not Paid"}</td>
                        <td>
                          {opt.isUploadCompleted ? "Uploaded" : "Not Uploaded"}
                        </td>
                      </>
                    )}
                    {tab == "pending" && (
                      <>
                        <td>
                          {opt.fee
                            ? `₦${Constants.formatCurrency(opt.fee)}`
                            : "N/A"}
                        </td>
                      </>
                    )}

                    {tab === "completed" && (
                      <td>
                        {opt.fee
                          ? `₦${Constants.formatCurrency(opt.fee)}`
                          : "N/A"}
                      </td>
                    )}
                    <td>
                      <JisButton
                        variant="plain"
                        onClick={() => onContinue(opt, index)}
                      >
                        View
                      </JisButton>
                    </td>
                    {tab == "revised" &&
                      (opt.isPaid && opt.isUploadCompleted ? (
                        <>
                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onUpdateFee(opt, index)}
                            >
                              Confirm Fees
                            </JisButton>
                          </td>
                        </>
                      ) : (
                        <td>N/A</td>
                      ))}
                    {tab == "pending" && (
                      <>
                        <td>
                          <JisButton
                            variant="plain"
                            onClick={() => onUpdateFee(opt, index)}
                          >
                            Confirm Fees
                          </JisButton>
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {cases?.length > 0 && (
          <Pagenated
            size={pageSize}
            total={count}
            maxPage={20}
            onPick={onPagePick}
            onChangePageSize={(k) => setPageSize(k)}
          />
        )}
      </div>
      <BackLoader open={loading} />

      {isGazette && (
        <div className={"preview open"} style={{ overflow: "scroll" }}>
          <div className="heading">
            <div className="buttongroup">
              <JisButton icon="close" onClick={() => setIsGazette(false)}>
                {" "}
                Close Preview
              </JisButton>
            </div>
          </div>

          <Gazette
            filingtypeid={active.case.caseFilingId}
            levelid={active.case.caseCategoryId}
            feetypeid={FeeTYPEID}
            token={token}
            onProceed={(e) => onGazetteProceed(e)}
            caseid={active.caseId}
            feeId={active.id}
            isShowAll
          >
            <div className="top-nav">
              <div className="left-top">
                <div className="top">
                  <h2>
                    {active.case.referenceNumber} |{" "}
                    {
                      Constants.getItemById(
                        frequentData.casecategories,
                        active.case.caseCategoryId
                      )?.categoryTitle
                    }
                  </h2>
                </div>
                <p>Select items related to the case that you are filing</p>
              </div>
              <p className="nav-status">Review Fees /Specifications</p>
            </div>
          </Gazette>

          <div className="date-btns"></div>
        </div>
      )}

      {/* {openCase && active != null && (
        <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )} */}
    </div>
  );
}

export default PsaCases;
